export default __webpack_public_path__ + "static/media/zm.0a4b97cc.svg";